module.exports = __webpack_public_path__ + "static/39-182865355af9196269cee92b5fbf42c1.jpg";